var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"item-features"},[(_vm.header)?_c('li',{staticClass:"item-features__content"},[_vm._v(_vm._s(_vm.$tf('attributes') + ':'))]):_vm._e(),_vm._l((_vm.formattedFeatures),function(ref){
var name = ref.name;
var value = ref.value;
return _c('li',{key:name,staticClass:"item-features__content"},[_vm._v(_vm._s(name)+": "+_vm._s(value))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }